<template>
  <div class="topmain">
    <div><van-nav-bar title="MCDEX时讯"></van-nav-bar></div>
    <div class="titlesubbig bottonline deptclass">
      <span style="color:#1989fa;" @click="showPicker = true">{{issdate}}年</span>
      <span style="padding-left:0.1rem;">共发布<span style="color:#F05F21">{{count}}</span>期</span>
    </div>
    <div class="contentscoll">
      <van-cell is-link v-for="(item,index) in data" :key="index" @click="Totitle(item)">
        <!-- 使用 title 插槽来自定义标题 -->
        <template #title>
          <span class="custom-title">{{item.Mc_issue}}<span style="padding-left:0.1rem;color:#666;">({{item.Datatime}})</span></span>
          <i v-show="item.Nid==1" style="color:#F05F21">new</i>
        </template>
      </van-cell>
    </div>

    <div style="height:0.5rem;width:100%;"></div>
   <van-tabbar active-color="#1989fa"  inactive-color="#000" route>
      <!-- <van-tabbar-item replace to="/home" icon="wap-home-o">首页</van-tabbar-item> -->
      <van-tabbar-item replace to="/" icon="apps-o">科室分类</van-tabbar-item>
      <van-tabbar-item replace to="/PublicTime" icon="clock-o">发布时间</van-tabbar-item>
      <van-tabbar-item replace to="/Search" icon="search">搜索</van-tabbar-item>    
    </van-tabbar>
    <!-- 下拉 -->
     <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
     </van-popup>
  </div>
</template>

<script>
export default {
  name: 'PublicTime',  
  data () {
    return {
      columns:[],
      showPicker:false,
      issdate:'2020',
      count:0,
      data:[],
      sourcedata:[],    
    }
  },
  created(){
      this.LoadData();
  },
  methods:{
      LoadData(){
      this.$axios
      .get(window.apiUrl+"/pc/mcdex/GetallMnList", {
        params: {
          
        }
      })
      .then(res => {
        if (res.data.Errs.length == 0) {
          var date=new Date();
          res.data.Result.forEach(element => {
            this.columns.push(element.Years);
            if(element.Years==date.getFullYear()){
              this.data.push(element);
            }
          });
          this.columns=this.distinctArr(this.columns).reverse();
          this.issdate=this.columns[0];
          this.count=this.data.length;
          this.sourcedata=res.data.Result;
        }
      });
      },    
      onConfirm(value, index) {      
        this.showPicker = false;
        this.issdate=value;
        this.data=[];
        this.sourcedata.forEach(element => {
          if(value==element.Years){
            this.data.push(element);
          }
        });
        this.count=this.data.length;
    }, 
    Totitle(item){
      sessionStorage.setItem("Listid", item.Listid);
      sessionStorage.setItem("Mc_issue", item.Mc_issue);
      this.$router.push({name: "PublicTiemTitle"});
    },  
    /**
   * 单个数组去重
   * @param {*} arr 
   * @param {*} compareFunc 
   */
  distinctArr(arr, compareFunc){
		arr = arr.sort();
		var pre = null;
		if(!!!compareFunc ||(typeof compareFunc).toUpperCase()!="FUNCTION") compareFunc = function(a,b){return a==b;};

		for(var i = 0;i<arr.length;i++){
			var item = arr[i];
			if(i == 0){
				pre = item; 
				continue;
			}
			if(compareFunc(item, pre)){
				arr.splice(i,1);
				i--;
			}
			pre = item;
		}
		return arr;
  },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.deptclass{
  height: 0.34rem;
  line-height: 0.34rem;
  padding-left: 0.1rem;
  background: #F2EEEE;
}
.all{
  color: #1989fa;
  float: right;
  margin-right: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/PublicTime.vue